export { DiplomaModel } from './Diploma.model';
